import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import reportWebVitals from './reportWebVitals';

const THEME_STORAGE_KEY = 'naijanest_theme';

try {
  const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
  const initialTheme = storedTheme === 'dark' || storedTheme === 'light' ? storedTheme : 'light';
  document.documentElement.setAttribute('data-theme', initialTheme);
  document.documentElement.style.colorScheme = initialTheme;
} catch {
  document.documentElement.setAttribute('data-theme', 'light');
  document.documentElement.style.colorScheme = 'light';
}

// Google's identity SDK is loaded by GoogleOAuthProvider wherever App.js
// mounts it (only on /login, /signup, and once functional-cookie consent is
// given) - not here, so it never loads for a visitor who hasn't asked for
// it or consented. See googleClientId() in App.js.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AppErrorBoundary>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <App />
        </BrowserRouter>
      </AppErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>
);

// Send Core Web Vitals to GA4 as events. No-ops silently if gtag hasn't
// loaded (analytics cookie consent not yet granted - see
// CookieConsentContext/analyticsLoader.js), so this never sends data
// before the visitor has opted in.
function sendWebVitalsToAnalytics({ name, delta, id, value }) {
  if (typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('event', name, {
    event_category: 'Web Vitals',
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    metric_id: id,
    metric_value: value,
    metric_delta: delta,
    non_interaction: true,
  });
}

reportWebVitals(sendWebVitalsToAnalytics);
